import { app } from "../serviceLMS";

export const getStatistics = async (userId) => {
  try {
    const endpoint = `/user/api/client-api/users/${userId}/statistics`;
    const response = await app.get(endpoint);

    return response.data.data;
  } catch (error) {
    console.error("Error fetching statistics:", error);
    throw error;
  }
};

export const getDeadline = async() => {
  try{
    const endpoint = `user/api/client-api/users/getDeadlines`;
    const response = await app.get(endpoint);

    return response.data.data;
  }
  catch(error){
    throw error;
  }
}
